import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import Colors from '../resource/ResourceColors.jsx';

import ViewerTracks from './viewers/ViewerTracks.jsx';
import ViewerHarmonies from './viewers/ViewerHarmonies.jsx';
import ViewerCode from './viewers/ViewerCode.jsx';

export const FILES_TOP_REM = 15.5;
export const FILES_HEADER_TOP_REM = 13.65;
const FIELD_BACKGROUND = Colors.right_diagonal_gradient(30, 20);

const NoFilesBody = styled.div`
    position:fixed;
    overflow:auto;
    top: ${FILES_HEADER_TOP_REM}rem;
    bottom: 0;
    left: 0;    
    right: 0;
    background: ${Colors.right_diagonal_gradient(30, 10)};
`;

const ViewerField = styled.div`
    position:fixed;
    overflow:auto;
    top: ${FILES_TOP_REM}rem;
    bottom: 0;
    left: 0;    
    right: 0;    
    background: ${FIELD_BACKGROUND};
`;

const NoFilesPrompt = styled.div`    
    text-align: center;
    margin-top: 5%;
    color: ${Colors.primary(90)};
`;

const FilesHeader = styled.div`
    position:fixed;
    top: ${FILES_HEADER_TOP_REM}rem;
    height: ${FILES_TOP_REM - FILES_HEADER_TOP_REM}rem;
    color: ${Colors.primary(90)};
    left: 0;    
    right: 0;
    background: ${Colors.right_diagonal_gradient(50, 30)};
    box-shadow: inset ${Colors.wide_raw_shadow(20)};
`;

const ViewSelector = styled.div`
    display: inline-block;    
    font-family: Courier;
    font-weight: bold;
    font-size: 0.75rem;    
    border-radius: 0.25rem;    
    padding: 0.15rem 1rem;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
    text-shadow: ${Colors.tight_text_shadow(90)};
    box-shadow: ${Colors.wide_raw_shadow(20)};
    letter-spacing: 0.15rem;
`;

const VIEW_TRACKS = "tracker";
const VIEW_HARMONIES = "chordal";
const VIEW_SCALAR_MATRIX = "scalar";
const VIEW_CODE = "hacker";
const VIEW_WALKER = "walker";
const ALL_VIEWERS = [
    VIEW_TRACKS,
    VIEW_HARMONIES,
    VIEW_SCALAR_MATRIX,
    VIEW_CODE,
    VIEW_WALKER,
];

export class AppFiles extends Component {

    static propTypes = {
        events: PropTypes.object
    }

    state = {
        content: null,
        events: null,
        file_meta: null,
        viewer: null
    };

    select_viewer(viewer, events) {
        if (viewer === this.state.viewer) {
            return;
        }
        let view_component = [];
        switch (viewer) {
            case VIEW_TRACKS:
                view_component = <ViewerTracks events={events}/>;
                break;
            case VIEW_HARMONIES:
                view_component = <ViewerHarmonies events={events}/>;
                break;
            case VIEW_CODE:
                view_component = <ViewerCode events={events}/>;
                break;
            case VIEW_SCALAR_MATRIX:
                view_component = <ViewerCode events={events}/>;
                break;
            case VIEW_WALKER:
                view_component = <ViewerCode events={events}/>;
                break;
            default:
                break;
        }
        const deselected_viewer = {
            color: Colors.primary(80),
            background: Colors.right_diagonal_gradient(60, 40),
            border: `${Colors.primary(25)} 0.1rem solid`,
            cursor: 'pointer'
        };
        const selected_viewer = {
            color: Colors.primary(95),
            background: Colors.right_diagonal_gradient(40, 20),
            border: `${Colors.primary(90)} 0.1rem solid`,
            cursor: 'default'
        };
        const file_viewers = ALL_VIEWERS.map(v => {
            const style = v === viewer ? selected_viewer : deselected_viewer;
            return <ViewSelector style={style} onClick={e => this.select_viewer(v, events)}>{v}</ViewSelector>
        });
        const content = <div>
            <FilesHeader>{file_viewers}</FilesHeader>
            <ViewerField>
                {view_component}
            </ViewerField>
        </div>;
        this.setState({
            content: content,
            viewer: viewer
        });
    }

    load_file(events, file_meta) {
        this.select_viewer(VIEW_TRACKS, events);
        this.setState({
            events: events,
            file_meta: file_meta
        });
    }

    render() {
        return this.state.content ? this.state.content :
            <NoFilesBody><NoFilesPrompt>Open or create a file above</NoFilesPrompt></NoFilesBody>;
    }
}

export default AppFiles;

